import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility to conditionally join classNames with Tailwind conflict resolution.
 *
 * @example
 * cn('px-2', condition && 'text-red-500') // → 'px-2 text-red-500'
 * cn('bg-red-500', 'bg-blue-500') // → 'bg-blue-500'
 *
 * @param inputs - List of class name values, accepts conditional logic via clsx
 * @returns A single deduplicated string of class names
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(...inputs));
